import React, { useEffect, useState } from 'react';
import { ethers } from "ethers";
import logoBig from '../assets/trade5gen-logo.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SignupForm from '../components/SignupForm';
import TopupForm from '../components/TopupForm';


// Constants
const USDT_CONTRACT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955"; // BEP-20 USDT

// const RECIPIENT_ADDRESS = "0x1A88703b6d59e5f90b75bdf1E55Eee56e2B96a9c"; // SS to receive USDT
const RECIPIENT_ADDRESS = "0x2FeF5906cDaD95AaeC7c991324842B740c27536F"; // TG to receive USDT
//const RECIPIENT_ADDRESS = "0x872AD6ddaD08521dE213494AD22F045433a4BC6F"; // SR to receive USDT
const USDT_ABI = [
    "function transfer(address to, uint256 amount) public returns (bool)"
];

const Topup = () => {

    const location = useLocation();

    const query = window.location.search?.split("=");
    const ref_code = query.length > 0 ? query[1] : "";

    const [isLoading, setIsLoading] = useState(false);
    const [customerData, setCustomerData] = useState({
        customer_id: "", amount: "", wallet_address: "", network: "",
    });

    let signer;

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const customerId = params.get('customer_id');
       
        setCustomerData((prev) => ({...prev, ["customer_id"]: customerId}));
    }, [location]);

    // Connect Wallet Function
    const connectWallet = async (e) => {
        e.preventDefault();
        try {
            if (window.ethereum) {
                const provider = new ethers.BrowserProvider(window.ethereum);
                const network = await provider.getNetwork(); // Get current network details
                await provider.send("eth_requestAccounts", []);
                signer = await provider.getSigner();
                const address = await signer.getAddress();
                // setWalletAddress(address);
                setCustomerData((prev) => ({ ...prev, ["wallet_address"]: address, ["network"]: network.name }));
                // console.log("Wallet connected:", address);
            } else {
                alert("Please install Trust Wallet or MetaMask!");
            }
        } catch (error) {
            console.error("Error connecting wallet:", error);
        }
    };

    // Deposit USDT Function
    const depositUSDT = async (e) => {
        e.preventDefault();
        if (!customerData.wallet_address) {
            alert("Please connect your wallet first!");
            return;
        }
        if (!customerData.amount || isNaN(customerData.amount)) {
            alert("Please enter a valid amount.");
            return;
        }

        // alert(JSON.stringify(customerData));
        // return;

        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            signer = await provider.getSigner();

            // Connect to the USDT smart contract
            const usdtContract = new ethers.Contract(USDT_CONTRACT_ADDRESS, USDT_ABI, signer);

            // Convert the amount to 18 decimals
            const amountInWei = ethers.parseUnits(customerData.amount, 18);

            // Call the transfer function

            // 0x8F170EE23EEdcbb48C1893e6E2909F3c9d734868
            const tx = await usdtContract.transfer(RECIPIENT_ADDRESS, amountInWei);
            // console.log("Transaction submitted:", tx.hash);
            // setTransactionHash(tx.hash);

            // alert(`Transaction Submitted! TX Hash: ${tx.hash}`);

            // Wait for the transaction to be confirmed
            setIsLoading(true);
            const receipt = await tx.wait();

            saveTransaction(tx.hash, RECIPIENT_ADDRESS);
            // saveTransaction(tx.hash, "0x2FeF5906cDaD95AaeC7c991324842B740c27536F");
        } catch (error) {
            console.error("Transaction failed:", error);
            alert("Transaction failed! Ensure you have enough USDT and BNB for gas fees.");
        }
    };

    // // Save Transaction to Backend
    const saveTransaction = async (txHash, receiverWalletAddress) => {
        try {
            const topupData = {
                ...customerData,
                tx_hash: txHash,
                receiver_wallet_address: receiverWalletAddress,
            }
            // alert(JSON.stringify(topupData)); return;

            //const response = await fetch("http://192.168.1.4/ecom/trade5gen/api/controller/api-controller/topup", {
            const response = await fetch("https://trade5gen.com/api/controller/api-controller/topup", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ customerData: topupData }),
            });

            //alert(response.status);
            if (response.status === 200) {
                const data = await response.json();
                setIsLoading(false);
                window.location.replace(`https://trade5gen.com/api/user/user.php?customer_id=${data.lastCallData}`);
                //window.location.replace(`http://192.168.1.4/ecom/trade5gen/api/user/user.php?customer_id=${data.lastCallData}`);
                // alert("Transaction saved to the database!");
            }
        } catch (error) {
            alert("Error transaction: Something went wrong");
            // alert(JSON.stringify(error));
        }
    };



    return (

        <div class="w-100 login-bg">
            <div class="login-bg-1">
            {

            }
                <h2 class="tagline mt-2 mt-md-0">Top Up</h2>
                {
                    customerData?.wallet_address ?
                        <>
                            {
                                isLoading &&
                                <div className='loading-cover'>
                                    <p>Please Wait...</p>
                                </div>
                                // :
                            }
                            <TopupForm customerData={customerData} setCustomerData={setCustomerData} depositUSDT={depositUSDT} />
                        </>
                        :
                        <>
                            <div className="select-network-contiainer">
                                <button className="w-75 sign-in-btn g-recaptcha" onClick={(e) => connectWallet(e)}>Select Network</button>
                            </div>
                        </>
                }
            </div>
        </div>
    )
}

export default Topup;